import React, { Suspense, lazy } from 'react';
import { CircularProgress, Box } from '@mui/material';

const ImportLeads = lazy(
  () => import('../../../../../components/Leads/ImportLeads.tsx')
);

/** Lazy-loads the multi-source import wizard (embedded full-screen dialog). */
export default function ImportExternalSourcesDialog({ open, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <Suspense
      fallback={(
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <CircularProgress />
        </Box>
      )}
    >
      <ImportLeads embedded onClose={onClose} />
    </Suspense>
  );
}
